var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Bookmarked",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-bookmarked","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <polygon points="52.3,5 195.4,5 195.4,246.5 123.8,167.2 52.3,246.5"/>
  <path d="M52.3 10h143.1l-5-5v241.5c2.8-1.2 5.7-2.4 8.5-3.5-20.9-23.2-41.8-46.3-62.6-69.5-3-3.3-5.9-6.6-8.9-9.9-1.7-1.9-5.3-1.9-7.1 0-20.9 23.2-41.8 46.3-62.6 69.5-3 3.3-5.9 6.6-8.9 9.9 2.8 1.2 5.7 2.4 8.5 3.5V5c0-6.4-10-6.4-10 0v241.5c0 4.2 5.6 6.8 8.5 3.5 20.9-23.2 41.8-46.3 62.6-69.5 3-3.3 5.9-6.6 8.9-9.9h-7.1c20.9 23.2 41.8 46.3 62.6 69.5 3 3.3 5.9 6.6 8.9 9.9 3 3.3 8.5.6 8.5-3.5V5c0-2.7-2.3-5-5-5H52.3c-6.5 0-6.5 10 0 10z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/bookmarked.svg